import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/person-assignment/PersonAssignmentAction";
import { CustomSelect, FormButton, getAuthorities, NoticeReceipentType, NoticeReceipentTypeOptions, redirectToPages, UserType, UserTypeOptions } from "../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { TeachersPage } from "./teachers/TeachersPage";

export function PersonAndNoticeGroupsPage({
  history,
  match: {
    params: { initialReceipentType }
  }
}) {
  const [receipentType, setReceipentType] = useState(parseInt(initialReceipentType));

  // Getting curret state of Person Assignment from store (Redux)
  const dispatch = useDispatch();
  const { actionLoading, isSuccess, type, authorities } = useSelector(
    (state) => ({
      actionLoading: state.personAssignment.actionLoading,
      isSuccess: state.personAssignment.isSuccess,
      type: state.personAssignment.type,
      authorities: state.personAssignment.authorities
    }),
    shallowEqual
  );

  // Authority Parameters
  const { isEditionAuthorized } = getAuthorities(authorities);
  
  useEffect(() => {
    dispatch(actions.getList());
    //return () => dispatch(actions.cleanList());
  }, [dispatch]);

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  const userTypeOptions = UserTypeOptions.filter(option => option.value !== UserType.System);
  
  return (
    <>
      <Card>
        {actionLoading && <ModalProgressBar />}
        <CardHeader title="Kişi ve Duyuru Grubu Listesi">
          {
            isEditionAuthorized &&
            <CardHeaderToolbar>                    
              <FormButton 
                path="Navigation/Check"
                title="Kişi Atama"
                method={() => history.push("/kisi-ve-duyuru-gruplari/kisi-atama")}
              />         
            </CardHeaderToolbar>
          }
        </CardHeader>
        <CardBody>
          <div className="form-group row">
            <div className="col-3 mt-3">
              Kişiler
            </div>
            <div className="col-4">
              <CustomSelect
                options={NoticeReceipentTypeOptions}
                value={receipentType}
                onChange={option => setReceipentType(option.value)}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      {/* {
        userType === UserType.Personnel &&
        <PersonnelUsersPage />
      } */}
      {
        receipentType === NoticeReceipentType.Teacher &&
        <TeachersPage />
      }
      {/* {
        userType === UserType.Student &&
        <StudentUsersPage />
      }
      {
        userType === UserType.Parent &&
        <ParentUsersPage />
      } */}
    </>    
  );
}